<div [class.single-tag-input--error]="control.touched && !control.valid" class="single-tag-input">
  <ng-content></ng-content>
</div>

<wp-input-error *ngIf="control?.touched && !control.valid">
  <ng-content select="[slot=error]"></ng-content>
</wp-input-error>
